import { QzTrayPayloadDTO } from "../../types/qztray/QzTrayTypes";

export const fakeBackendPayload = {
  title: "Payload generado correctamente",
  message: "El payload QZ Tray fue generado exitosamente para el documento solicitado.",
  statusCode: 200,
  type: "success",

  data: <QzTrayPayloadDTO>{
    printer: "RPT004",
    type: "Térmica",

    commands: [
      // 🔹 Inicializar impresora (ESC @)
      {
        type: "RAW",
        value: "G0A=",
        size: null,
        align: null,
        style: null,
        lineFeed: false,
        format: "raw",
        flavor: "base64",
      },

      // 🔹 Encabezado
      {
        type: "TEXT",
        value: "G2EBG3QQGyEAUFJVRUJBIERFIElNUFJFU0nTTiAtIFNPTE8gVEVYVE8K",
        size: null,
        align: "center",
        style: "bold",
        lineFeed: false,
        format: "plain",
        flavor: "base64",
      },

      // 🔹 Separador
      {
        type: "RAW",
        value: "G2QB",
        size: null,
        align: null,
        style: null,
        lineFeed: false,
        format: "raw",
        flavor: "base64",
      },

      // 🔸 Texto
      {
        type: "TEXT",
        value: "G2EBG3QQGyEAU3R5bGVhcnQK",
        size: null,
        align: "left",
        style: null,
        lineFeed: false,
        format: "plain",
        flavor: "base64",
      },
      {
        type: "TEXT",
        value: "G2EBG3QQGyEAT3Ryb3MgQ29udHJpYnV5ZW50ZXMK",
        size: null,
        align: "left",
        style: null,
        lineFeed: false,
        format: "plain",
        flavor: "base64",
      },
      {
        type: "TEXT",
        value: "G2EBG3QQGyEAVmVudGEgYWwgcG9yIG1lbm9yIGRlIHByZW5kYXMgZGUgdmVzdGlyIHkgYWNjZXNvcmlvcyBkZSB2ZXN0aXIK",
        size: null,
        align: "left",
        style: null,
        lineFeed: false,
        format: "plain",
        flavor: "base64",
      },
      {
        type: "TEXT",
        value: "G2EBG3QQGyEAoUdyYWNpYXMgcG9yIHByZWZlcmlybm9zIQo=",
        size: null,
        align: "left",
        style: null,
        lineFeed: false,
        format: "plain",
        flavor: "base64",
      },

      // 🔹 Footer
      {
        type: "TEXT",
        value: "G2EBG3QQGyEATvptZXJvICMgNTIK",
        size: null,
        align: "left",
        style: null,
        lineFeed: false,
        format: "plain",
        flavor: "base64",
      },

      // 🔹 FEED
      {
        type: "RAW",
        value: "G2QB",
        size: null,
        align: null,
        style: null,
        lineFeed: false,
        format: "raw",
        flavor: "base64",
      },

      // 🔹 Feed extra
      {
        type: "RAW",
        value: "G2QC",
        size: null,
        align: null,
        style: null,
        lineFeed: false,
        format: "raw",
        flavor: "base64",
      },

      // ✂️ Corte
      {
        type: "RAW",
        value: "HVYA",
        size: null,
        align: null,
        style: null,
        lineFeed: false,
        format: "raw",
        flavor: "base64",
      },
    ],

    preview: null,
    metadata: null,
  },
};
